module.exports = __webpack_public_path__ + "img/cadeira_verde.6f630001.png";